import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AngularFireStorage} from '@angular/fire/storage';
import {MarketingItemService} from '../../service/marketing-item.service';
import {MarketingItemModel} from '../../models/marketing-item.model';
import {MAT_ICONS} from '../../../constant';

@Component({
  selector: 'app-marketing-item-modal',
  templateUrl: './marketing-item-modal.component.html',
  styleUrls: ['./marketing-item-modal.component.scss']
})
export class MarketingItemModalComponent implements OnInit {

  selectedMarketingItem: MarketingItemModel;
  form: FormGroup;
  matIcons: object[] = MAT_ICONS;


  constructor(
    private fb: FormBuilder,
    private marketingService: MarketingItemService,
    private dialogRef: MatDialogRef<MarketingItemModalComponent>,
    private storage: AngularFireStorage,
    @Inject(MAT_DIALOG_DATA) marketingItem: MarketingItemModel) {

    this.selectedMarketingItem = marketingItem;

    this.form = fb.group({
      title: [this.selectedMarketingItem.title, Validators.required],
      description: [this.selectedMarketingItem.description],
      icon: [this.selectedMarketingItem.icon]
    });

  }


  ngOnInit() {

  }

  save() {

    if (!this.form.valid) {
      return;
    }

    if (this.selectedMarketingItem.id) {
      this.marketingService.editMarketingItemItem({
        ...this.selectedMarketingItem, ...this.form.value,
        updatedAt: new Date().getTime()
      });
    } else {
      this.marketingService.createMarketingItemItem({
        ...this.form.value,
        createdAt: new Date().getTime(),
        updatedAt: new Date().getTime()
      });
    }

    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }

  handlePrimaryColorChanged(event) {
    this.selectedMarketingItem.primaryColor = event.color.hex;
  }


}
